export default "__VITE_ASSET__56bf5d42__"